import { LoadingPage } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 1);

  > div > div {
    h2,
    p {
      text-align: center;
      line-height: initial;
    }
  }
`

type LoadingProps = {
  active: boolean
  des?: React.ReactNode
  complement?: React.ReactNode
}

const Loading = ({ active, des, complement }: LoadingProps) => {
  if (!active) {
    return null
  }

  return (
    <LoadingOverlay>
      <LoadingPage des={des} complement={complement} />
    </LoadingOverlay>
  )
}

export default Loading
